import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=e2654064&scoped=true&"
import script from "./addAndEdit.vue?vue&type=script&lang=js&"
export * from "./addAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&id=e2654064&prod&scoped=true&lang=css&"
import style1 from "./addAndEdit.vue?vue&type=style&index=1&id=e2654064&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2654064",
  null
  
)

export default component.exports